import type {Metadata} from 'next';
import {Rubik} from 'next/font/google';
import './index.scss';
import HeaderPublic from '@/shared/layouts/header/HeaderPublic';
import I18nProvider from '@/shared/provider/I18nProvider';
import MuiProvider from '@/shared/provider/MuiProvider';

const rubikSans = Rubik({
    variable: '--font-rubik-sans',
    subsets: ['latin'],
});

export const metadata: Metadata = {
    title: 'App | influence.vision',
    description:
        'Your #1 software with integrated services for successful influencer campaigns. Book, manage, and measure your campaigns all in one place.',
};

export default function RootLayout({
                                       children,
                                   }: Readonly<{
    children: React.ReactNode;
}>) {
    return (
        <html lang='en'>
        <body className={`${rubikSans.variable}`}>
        <I18nProvider>
            <MuiProvider>
                <HeaderPublic/>
                <div className='container-fluid'>{children}</div>
            </MuiProvider>
        </I18nProvider>

        </body>
        </html>
    );
}
